import React, { useRef, useState } from "react";
import iconEllipsis from "../../../assets/images/icons/ellipsis.svg";
import iconMarkAsUnread from "../../../assets/images/icons/unread.svg";
import iconMarkAsRead from "../../../assets/images/icons/read.svg";
import {
  MessageActionModal,
  MessageActionItemList,
  MessageActionItemItem
} from "../../../styles/common";
import { checkTokenValidity } from "../../../utils/utils";
import { useAuth } from '../../../context/AuthProvider/useAuth';
import { fireAlert, fireSuccess, formatDate } from "../../../utils/utils";
import { MessageActionsButton, MessageActionsContainer } from "../../contacts/style";
import MessageContent from "../../../components/fragments/messageContent";
import { appendAttachmentFields } from "../../../utils/whatsappMessages";

const REACTION_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

export default function ItemOut({
  item,
  index,
  lineId,
  isgroup,
  setLoading,
  details,
  setDetails
}) {
    const [viewAllModal, setViewAllModal] = useState(false);
    const [messageActions, setMessageActions] = useState(0);
    const [sendingReaction, setSendingReaction] = useState(false);
    const messageRef = useRef();
    const auth = useAuth();

    const fetchReadUnreadMessage = async (pContact, pMessage, status) => {
        try {
            setLoading(true);
            await auth.putChatStatus({
                lineid: lineId,
                contactid: pContact,
                chatid: pMessage,
                status
            });

            const newDetails = details.filter((item) => {
                if (item.id === pMessage) {
                    item.readstatus = status;
                }

                return item;
            });

            setDetails([...newDetails]);

            //status === 0 ? setTempUnreadMarked([...tempUnreadMarked, pMessage]) : setTempUnreadMarked(tempUnreadMarked.filter(d => d !== pMessage));
        } catch ({ response }) {
            //console.log(JSON.stringify(response));
            checkTokenValidity(response.data);
            fireAlert(response.data.message);
        } finally {
            setLoading(false);
        }
    }

    //reaction is a normal chat/send with msgtype reaction (contract payload)
    const sendReaction = async (emoji) => {
        if (!item.waid) {
            fireAlert("This message cannot be reacted to yet");
            return;
        }

        try {
            setSendingReaction(true);
            setLoading(true);

            const formData = new FormData();
            formData.append("lineid", lineId);
            formData.append("contactid", item.contactid);
            formData.append("message", emoji);
            formData.append("isgroup", isgroup ? 1 : 0);
            appendAttachmentFields(formData, {
                msgtype: "reaction",
                payload: { react_to_waid: item.waid, react_to_id: item.id, emoji }
            });

            await auth.postChatSend(formData);
            setViewAllModal(false);
            fireSuccess("Reaction sent");
        } catch ({ response }) {
            checkTokenValidity(response?.data);
            fireAlert(response?.data?.message);
        } finally {
            setSendingReaction(false);
            setLoading(false);
        }
    }

    return (
        <>
            <div className="d-flex flex-row justify-content-start" style={{ overflow: "hidden" }} key={index}>
                <div className="d-flex justify-content-between">
                    <p style={{ fontSize: 10 }} className="small mb-2 rounded-3 text-muted">{formatDate(item.createdat)}</p>
                    {//tempUnreadMarked.includes(item.id)
                        item.readstatus === 0 && <div className="d-flex ms-1 ms-auto"><img src={iconMarkAsUnread} width="20" height="20" alt="Icon Tic" /></div>}
                    <MessageActionsContainer>
                        <MessageActionsButton
                            active={viewAllModal}
                            onClick={() => {
                                setViewAllModal(!viewAllModal)
                                setMessageActions(item.id)
                            }}
                        >
                            <img src={iconEllipsis} width="15" height="15" alt="Ellipses" style={{ cursor: "pointer" }} className="mx-1" />
                        </MessageActionsButton>
                        <MessageActionModal ref={messageRef} active={viewAllModal && messageActions === item.id ? "true" : undefined}>
                            <MessageActionItemList>
                                {
                                    //!tempUnreadMarked.includes(item.id)
                                    item.readstatus === 1 ?
                                        <MessageActionItemItem
                                            active={undefined}
                                            onClick={() => {
                                                setViewAllModal(!viewAllModal);
                                                fetchReadUnreadMessage(item.contactid, item.id, 0)
                                            }}
                                        >
                                            <div className="d-flex w-auto">
                                                <img className="mt-1" src={iconMarkAsUnread} height="20" alt="Icon Tic" />
                                                <span style={{ fontSize: 10, color: "#640180" }} >Mark as Unread</span>
                                            </div>
                                        </MessageActionItemItem>
                                        :
                                        <MessageActionItemItem
                                            active={undefined}
                                            onClick={() => {
                                                setViewAllModal(!viewAllModal);
                                                fetchReadUnreadMessage(item.contactid, item.id, 1)
                                            }}
                                        >
                                            <div className="d-flex">
                                                <img className="mt-1" src={iconMarkAsRead} width="20" height="20" alt="Icon Tic" />
                                                <span style={{ fontSize: 10, color: "#640180" }}>Mark as Read</span>
                                            </div>
                                        </MessageActionItemItem>
                                }
                            </MessageActionItemList>
                            <div className="d-flex flex-row justify-content-between px-2 py-1">
                                {REACTION_EMOJIS.map((emoji) => (
                                    <span
                                        key={emoji}
                                        title={"React with " + emoji}
                                        style={{ cursor: sendingReaction ? "default" : "pointer", fontSize: 16 }}
                                        onClick={() => !sendingReaction && sendReaction(emoji)}
                                    >
                                        {emoji}
                                    </span>
                                ))}
                            </div>
                        </MessageActionModal>
                    </MessageActionsContainer>
                </div>
            </div>
            <MessageContent item={item} variant="out" index={index} />
        </>
    )
}